import { createContext } from 'react';

import { ChatContextType } from '@/features/chat';

export const ChatContext = createContext({} as ChatContextType);
